import * as React from "react";
import { Controller } from "react-hook-form";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import { Box, Typography } from "@mui/material";

export default function FormSelect({ name, control, label, items, rules, disabled, sx }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', gap: 12, p: 2, alignItems: 'center', ...sx }}>
          {label && (
            <Typography sx={{ p: 1, width: 256 }}>{label}</Typography>
          )}
          <Select
            {...field}
            sx={{ width: 384, height: 40 }}
            defaultValue=""
            error={!!error}
            disabled={disabled}
          >
            {items.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText sx={{ color: '#ef4444' }}>{error?.message}</FormHelperText>
        </Box>
      )}
    />
  );
}
